<!--
  acntInfInp.vue ( 5 step, mblElcSgn05 )
  - 계좌정보입력
 -->
<template>
  <div id="wrap" class="wrap_layout">
    <Header :rtrnAnimInsYn="state.rtrnAnimInsYn" />
    <div class="container">
      <div class="contents">
        <!--Contents Area [s]-->
        <div class="section">
          <p class="tit_tbl mgt0">영수 및 기타사항(예금주 입력)</p>
          <div class="data_table type_row st_mix">
            <table>
              <caption class="blind">
                본인확인
              </caption>
              <colgroup>
                <col style="width: 95px" />
                <col />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">2회차 납입방법</th>
                  <td>
                    <div class="check_box">
                      <input
                        type="checkbox"
                        id="atTrsAgrYn"
                        v-model="state.atTrsAgrYn"
                      />
                      <label for="atTrsAgrYn">자동이체<span></span></label>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th scope="row">예금주명</th>
                  <td>{{ state.dporNm }}</td>
                </tr>
                <tr>
                  <th scope="row" class="dense">계약자와의<br />관계</th>
                  <td>{{ state.polhdRelNm }}</td>
                </tr>
                <tr>
                  <th scope="row">이체일</th>
                  <td>
                    <ul class="radio_list" id="trsDd">
                      <li>
                        <span
                          class="radio_box"
                          v-for="(vo, index) in state.trsDdLst"
                          :key="vo.efctVal"
                        >
                          <input
                            type="radio"
                            name="radioOption"
                            :id="'radio' + index"
                            :value="vo.efctVal"
                            v-model="state.trsDd"
                          />
                          <label :for="'radio' + index">{{
                            vo.efctValNm
                          }}</label>
                        </span>
                      </li>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <th scope="row">은행</th>
                  <td>
                    <input
                      type="text"
                      class="inputBox type_select"
                      readonly
                      :value="state.bankCd.efctValNm"
                      @click="openSelect('bankCd')"
                    />
                  </td>
                </tr>
                <tr>
                  <th scope="row"><label>계좌번호</label></th>
                  <td>
                    <input
                      :type="state.acntNoInputType"
                      id="acntNo"
                      name="acntNo"
                      class="inputBox"
                      :value="state.acntNo"
                      placeholder="계좌번호를 입력해주세요."
                      ref="acntNoEl"
                      data-tk-kbdType="number"
                      onfocus="mtk.onKeyboard(this);"
                      @focus="keyPad"
                    />
                    <div class="mgt5">
                      <button
                        type="button"
                        class="btn_cont btn_round"
                        id="dporCnfEl"
                        @click="dporCnf"
                        v-if="!state.dporCnfFlag"
                      >
                        <span>예금주확인</span>
                      </button>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th scope="row" class="pdr0">통합이체동의</th>
                  <td>
                    <ul class="radio_list">
                      <li>
                        <span class="radio_box">
                          <input
                            type="radio"
                            id="option01"
                            name="radioOption2"
                            value="1"
                            v-model="state.itgrTrsAgr"
                          />
                          <label for="option01">동의</label>
                        </span>
                        <span class="radio_box">
                          <input
                            type="radio"
                            id="option02"
                            name="radioOption2"
                            value="2"
                            v-model="state.itgrTrsAgr"
                          />
                          <label for="option02">미동의</label>
                        </span>
                      </li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <ul class="txt_list">
            <li>예금주 본인계좌만 입력 가능합니다.</li>
            <li>
              <span class="point">평생계좌</span>는 실시간/자동이체 등록 및
              출금이 <span class="point">불가능</span>합니다.
            </li>
          </ul>
        </div>
        <div class="section line" v-if="state.rlhrRegYn">
          <p class="tit mgt5">선택사항</p>
          <div class="txt_confirm_wrap">
            <p>
              입력된 계좌를 1회보험료 납부를 위한 실시간이체계좌로
              등록하시겠습니까?
            </p>
            <p>
              (실시간이체를 위한 계좌등록만 진행되며, 즉시이체가 진행되지
              않습니다.)
            </p>
          </div>
          <ul class="radio_list_block" id="rlhrTrsYn">
            <li>
              <div class="radio_box">
                <input
                  type="radio"
                  id="optionSel01"
                  name="optionSel"
                  value="1"
                  v-model="state.rlhrAcntAttrYn"
                />
                <label for="optionSel01"
                  >예, 1회보험료 및 2회차이후보험료를 해당계좌로
                  등록합니다.</label
                >
              </div>
            </li>
            <li>
              <div class="radio_box">
                <input
                  type="radio"
                  id="optionSel02"
                  name="optionSel"
                  value="2"
                  v-model="state.rlhrAcntAttrYn"
                />
                <label for="optionSel02"
                  >아니오, 2회차이후보험료만 해당계좌로 등록합니다. (1회보험료
                  계좌는 계약자가 입력)</label
                >
              </div>
            </li>
          </ul>
        </div>
        <div class="btn_area masterBtn">
          <button type="button" class="btn_main" @click="acntInfStr">
            <span>{{ getMasterButton() }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { reactive, inject, onMounted, ref, nextTick } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import util from "@/common/util";
import { sessionUserInfo, load } from "@/common/sessionFactory";
import useDialog from "@/common/dialog";
import { flickingLayout, enableScroll } from "@/common/scrnCtrl";
import Header from "@/components/common/Header.vue";

export default {
  name: "acntInfInp",
  components: {
    Header,
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const axios = inject("axios");
    const dialog = useDialog(inject("$vfm"));

    const acntNoEl = ref(null);

    // 농협 계좌 제어 변수
    var bnkCdSpecial = "0ax";

    enableScroll();

    const state = reactive({
      currDate: util.formatDate(new Date(), "yyyymmdd"),
      rtrnAnimInsYn: false,
      polhdRelNm: "",
      /////////////////////////////////
      rlhrAcntAttrYn: "", // 실시간이체계좌등록여부
      /////////////////////////////////
      atTrsAgrYn: false, // 자동이체여부
      // rlhrTrsYn: 'N', // 실시간이체여부
      dporNm: "", // 예금주명
      trsDd: "", // 이체일
      dporCnfFlag: false, // 예금주 확인여부
      /////////////////////////////////
      polhdRel: { efctVal: "01", efctValNm: "본인", idfNo: "" },
      acntNo: "",
      trsDdLst: [], // 이체일 리스트
      bankCd: {}, // 은행
      itgrTrsAgr: "1", // 통합이체동의'
      acntNoInputType: "num",
    });

    var variables = {
      atTrsCoVo: {},
      prctrAtTrsAcntRegInfBcVo: {},
      polhdRelLst: [{ efctVal: "01", efctValNm: "본인", idfNo: "" }],
      keyClearFlag: false,
      bankCdLst: [],
      rlhrTrsPsbAcnt: [],
      sbcpChnFlag: false, // TM채널 여부
      pmmiCovYn: false,
      inempYn: false,
    };

    onMounted(async () => {
      await nextTick();
      await load();
      util.saveLog("009", "계좌정보입력"); // 009 : 화면진입
      transkey = [];
      mtk = null;
      tk_btn_arr = [];
      initmTranskey();

      mtk.closeCallBack = () => {
        state.acntNo = acntNoEl.value.value || "";
      };

      mtk.doneCallBack = () => {
        state.acntNo = acntNoEl.value.value || "";
      };

      if (sessionUserInfo == null) {
        router.push({ name: "sessionExpired" });
        return;
      }

      if (
        sessionUserInfo.rpsPdCd == "61139" ||
        sessionUserInfo.rpsPdCd == "61238" ||
        sessionUserInfo.rpsPdCd == "61239"
      ) {
        state.rtrnAnimInsYn = true;
      } else {
        state.rtrnAnimInsYn = false;
      }

      state.dporNm = sessionUserInfo.ctrBasInfCoVo[0].dporNm;

      let sbcpChnDivCd = sessionUserInfo.ctrBasInfCoVo[0].sbcpChnDivCd;

      //TM채널 여부
      if (sbcpChnDivCd == "11" || sbcpChnDivCd == "12") {
        variables.sbcpChnFlag = true;
      } else {
        variables.sbcpChnFlag = false;
      }

      retrievePrctrAtTrsAcnt();
    });

    // 자동이체 계좌정보 조회
    function retrievePrctrAtTrsAcnt() {
      axios.json("/retrievePrctrAtTrsAcnt.do", {}).then(function (result) {
        if (util.isNull(result.data.atTrsCoVo[0])) {
          variables.atTrsCoVo = {};
          variables.prctrAtTrsAcntRegInfBcVo = result.data.list[0];

          //자동이체 정보
          variables.atTrsCoVo.bizSysCd = "CTL";
          variables.atTrsCoVo.atTrsDivCd = "1";
          variables.atTrsCoVo.trsMdDivCd = "02";
          variables.atTrsCoVo.inpViaDivCd = "03";
          variables.atTrsCoVo.rqeDivCd = "1";
          variables.atTrsCoVo.rqeDt = state.currDate;
          variables.atTrsCoVo.rqepeRlRelCd = "01";
          variables.atTrsCoVo.rqepeCusId =
            variables.prctrAtTrsAcntRegInfBcVo.ptyId;
          variables.atTrsCoVo.ptyId = variables.prctrAtTrsAcntRegInfBcVo.ptyId;

          //당사자 정보
          variables.atTrsCoVo.rlAplRngDivCd = "0006";
          variables.atTrsCoVo.ctrPtyRlCd = "71";
          variables.atTrsCoVo.relPtyRlCd = "01";

          variables.atTrsCoVo.ptyDivCd =
            variables.prctrAtTrsAcntRegInfBcVo.ptyDivCd;
          variables.atTrsCoVo.cusNo = sessionUserInfo.cusNo;

          state.acntNo = "";

          //도메인정보호출
          retrieveDmnInf("201310220001", false);
          retrieveDmnInf("201109240136", false);
          retrieveDmnInf("201109240116", false);
        } else {
          variables.prctrAtTrsAcntRegInfBcVo = result.data.list[0];
          variables.atTrsCoVo = result.data.atTrsCoVo[0];
          variables.atTrsCoVo.rspnCd = variables.atTrsCoVo.fncInstCd;

          state.acntNo = variables.atTrsCoVo.regRefNoEncry;

          //도메인정보호출
          retrieveDmnInf("201310220001", true);
          retrieveDmnInf("201109240136", true);
          retrieveDmnInf("201109240116", true);
        }
      });
    }

    function retrieveDmnInf(DmnCode, initFlag) {
      var param = {};
      param.dmnVal = DmnCode;
      axios.json("/retrieveDmnInf.do", param).then(function (result) {
        if (result.data.row[0].dmnVal == "201310220001") {
          variables.bankCdLst = _.filter(result.data.row, function (info) {
            return (
              info.efctVal != "261" &&
              info.efctVal != "268" &&
              info.efctVal != "247" &&
              info.efctVal != "265" &&
              info.efctVal != "264" &&
              info.efctVal != "292" &&
              info.efctVal != "230"
            );
          });

          state.bankCd = _.find(
            variables.bankCdLst,
            (data) => data.efctVal == variables.atTrsCoVo?.fncInstCd
          );

          if (state.bankCd == null) state.bankCd = result.data.row[0];

          if (initFlag && sessionUserInfo.ctrBasInfCoVo[0].sbcpDt >= 20190101) {
            dporCnf();
          }
        } else if (result.data.row[0].dmnVal == "201109240136") {
          state.trsDdLst = _.filter(result.data.row, function (info) {
            return info.efctValNm != "말일";
          });
          state.trsDd = variables.atTrsCoVo?.trsDdCd ?? "";
        } else if (result.data.row[0].dmnVal == "201109240116") {
          let rlRelCdData = _.filter(result.data.row, function (info) {
            return info.efctVal == variables.atTrsCoVo.rlRelCd;
          });

          if (rlRelCdData.length > 0) {
            state.polhdRelNm = rlRelCdData[0].efctValNm;
          }

          if (
            variables.atTrsCoVo.rlRelCd == "02" ||
            variables.atTrsCoVo.rlRelCd == "03" ||
            variables.atTrsCoVo.rlRelCd == "04" ||
            variables.atTrsCoVo.rlRelCd == "05"
          ) {
            state.rlhrRegYn = true;
          } else {
            state.rlhrRegYn = false;
            state.rlhrAcntAttrYn = "2";
          }
        }
      });
    }

    const keyPad = () => {
      variables.keyClearFlag = true;
      state.dporCnfFlag = false;
      state.acntNoInputType = "password";
      state.acntNo = "";
    };

    /* 셀렉트 팝업 열기
            type  
             - polhdRel: 계약자와의 관계
             - bankCd: 은행
        */
    const openSelect = (type) => {
      if (variables[type + "Lst"].length <= 1) return false;

      dialog
        .select({
          label: "선택",
          name: "efctValNm",
          list: variables[type + "Lst"],
        })
        .then(function (res) {
          if (util.isEmpty(res) || util.isNull(res)) return;

          if (type == "polhdRel") {
            variables.keyClearFlag = true;
            state.polhdRel = res;
            state.acntNo = "";
            state.dporCnfFlag = false;

            let selectidfNo = _.filter(
              variables.globPolhdRelLst,
              function (info) {
                return info.idfNo == res.idfNo;
              }
            );
            if (selectidfNo.length > 0) {
              state.dporNm = selectidfNo[0].cusNm;
            } else {
              state.dporNm = sessionUserInfo.ctrBasInfCoVo.polhdNm;
            }
          } else if (type == "bankCd") {
            variables.keyClearFlag = true;
            state.bankCd = res;
            state.acntNo = "";
            state.dporCnfFlag = false;
          }
        });
    };

    const dporCnf = () => {
      //예금주 확인 초기화
      state.dporCnfFlag = false;

      if (util.isEmpty(acntNoEl.value.value)) {
        dialog
          .alert("계좌번호를 입력하세요.")
          .then(() => flickingLayout(acntNo));
        return false;
      }
      state.acntNo = acntNoEl.value.value;
      if (variables.keyClearFlag) {
        //암호화된 계좌번호
        let inputData = util.getMobileInputEncData(["acntNo"]);
        axios.reqPost("/solution/decode.do", inputData).then(function (result) {
          let decodeFlag = result.data.decodeFlag;
          if (decodeFlag) {
            let bankCd = state.bankCd.efctVal;
            let dporNm = state.dporNm;

            //평생계좌 확인
            axios.json("/retrieveExcePcsApvYn.do", {}).then(function (result) {
              let data = result.data;
              if (!util.isNull(data.msg) && data.msg.standCd == "FNGCT200517") {
                dialog.alert(data.msg.standMsg);
                state.acntNo = "";
                state.dporCnfFlag = false;
                return false;
              }
              //농협 기관코드 제어
              let tempInstCd = specInsCdcng(bankCd);

              bankCd = tempInstCd;

              //예금주조회
              fa_SearchDpor(bankCd, dporNm);
            });
          } else {
            dialog
              .alert("데이터 암호화 실패하였습니다.<br/>다시 시도해 주세요.")
              .then(function () {
                window.location.reload();
              });
          }
        });
      } else {
        let bankCd = state.bankCd.efctVal;
        let dporNm = state.dporNm;

        //평생계좌 확인
        axios.json("/retrieveExcePcsApvYn.do", {}).then(function (result) {
          let data = result.data;
          if (!util.isNull(data.msg) && data.msg.standCd == "FNGCT200517") {
            dialog.alert(data.msg.standMsg);
            state.acntNo = "";
            state.dporCnfFlag = false;
            return false;
          }
          //농협 기관코드 제어
          var tempInstCd = specInsCdcng(bankCd);

          bankCd = tempInstCd;
          //예금주조회
          fa_SearchDpor(bankCd, dporNm);
        });
      }
    };

    // 농협 기관코드 제어
    function specInsCdcng(bankCd) {
      if (bankCd == bnkCdSpecial) {
        bankCd = "011";
      }
      variables.atTrsCoVo.fncInstCd = bankCd;
      return bankCd;
    }

    //예금주조회
    function fa_SearchDpor(bankCd, inputDporNm) {
      let param = {};
      param.fncInstCd = bankCd;

      axios.json("/retrieveDpor.do", param).then(function (result) {
        let list = result.data.list[0];
        if (list != undefined && !util.isNull(list)) {
          let { dporNm, otsdInstRspnCon, inqDiv, otsdInstRspnCd } = list;

          list.dporNm = dporNm?.trim();
          list.otsdInstRspnCon = otsdInstRspnCon;

          let param = {};
          param.dmnVal = "201203300012";
          axios.json("/retrieveDmnInf.do", param).then(function (result) {
            let object = _.filter(result.data.row, function (info) {
              return info.efctVal == bankCd;
            });

            //실시간 이체 가능계좌 리스트 셋팅
            variables.rlhrTrsPsbAcnt = result.data.row;

            if (object.length > 0) {
              inqDiv = "1";
            } else {
              inqDiv = "2";
            }

            if (inqDiv == "1") {
              //은행전용선망
              if (otsdInstRspnCd == "0000") {
                list.dporCnfDivCd = "1"; //예금주코드 정상
              } else {
                list.dporCnfDivCd = "2"; //예금주코드 불일치
              }
            } else {
              //전자금융공동망
              if (otsdInstRspnCd == "0000") {
                if (inputDporNm == list.dporNm) {
                  list.dporCnfDivCd = "3"; //예금주명 일치
                } else {
                  list.dporCnfDivCd = "4"; //예금주명 불일치
                }
              } else {
                list.dporCnfDivCd = "4"; //예금주명 불일치
              }
            }

            if (otsdInstRspnCd != "0000") {
              let Attrs_ErrorMsg = "";
              //오류결과에 따라 메시지 설정
              if (!util.isNull(otsdInstRspnCon) && otsdInstRspnCon != "") {
                Attrs_ErrorMsg = otsdInstRspnCon;
              } else {
                Attrs_ErrorMsg = "계좌번호 또는 예금주가 올바르지 않습니다.";
              }
              dialog.alert(Attrs_ErrorMsg);
              state.acntNo = "";
              return;
            } else {
              let msgCon = "";

              // 	예금주확인구분코드
              // 	1: 예금주코드 정상     - 예금주코드 확인해주는 은행인경우
              // 	2: 예금주코드 불일치  - 예금주코드 확인해주는 은행인경우
              // 	3: 예금주명 일치        - 예금주명만 알려주는 은행인경우
              // 	4: 예금주명 불일치     - 예금주명만 알려주는 은행인경우
              let dporCnfDivCd = list.dporCnfDivCd;

              if (dporCnfDivCd == "2") {
                dialog.alert("예금주코드가 일치 하지 않습니다.");
                state.acntNo = "";
                return;
              } else if (dporCnfDivCd == "4") {
                msgCon = "예금주명이 일치 하지 않습니다.";
                variables.atTrsCoVo.dporChkYn = "2";
                variables.atTrsCoVo.dporRnmCnfYn = "2";
              } else {
                variables.atTrsCoVo.dporChkYn = "1";
                variables.atTrsCoVo.dporRnmCnfYn = "1";
              }

              variables.atTrsCoVo.empAcntYn = "";
              if (msgCon != "") {
                dialog.alert(msgCon);
                state.acntNo = "";
                return;
              }
            }

            dialog.alert("예금주 확인이 되었습니다.").then(function () {
              state.dporCnfFlag = true;
            });
          });

          /******* 농협 금융기관코드 제어 ************/
          if (
            variables.atTrsCoVo.fncInstCd == "011" ||
            variables.atTrsCoVo.fncInstCd == "012"
          ) {
            variables.atTrsCoVo.rspnCd = bnkCdSpecial;
          } else {
            variables.atTrsCoVo.rspnCd = variables.atTrsCoVo.fncInstCd;
          }
        } else {
          if (!util.isNull(result.data.msg)) {
            dialog.alert(result.data.msg.standMsg).then(function () {
              window.location.reload();
            });
          } else {
            dialog.alert("예금주 확인이 실패하였습니다.").then(function () {
              window.location.reload();
            });
          }
        }
      });
    }

    const acntInfStr = () => {
      if (!state.atTrsAgrYn) {
        dialog
          .alert("자동이체를 체크하세요.")
          .then(() => flickingLayout(atTrsAgrYn, true));
        return false;
      }

      if (util.isEmpty(state.trsDd)) {
        dialog
          .alert("이체일을 선택하세요.")
          .then(() => flickingLayout(trsDd, true));
        return false;
      }

      if (!state.dporCnfFlag) {
        dialog
          .alert("예금주 확인을 진행해주세요.")
          .then(() => flickingLayout(dporCnfEl, true));
        return false;
      }

      if (util.isEmpty(state.rlhrAcntAttrYn)) {
        dialog
          .alert("실시간 자동이체 여부를 선택하세요.")
          .then(() => flickingLayout(rlhrTrsYn, true));
        return false;
      }

      //실시간 이체 가능 계좌
      let rlhrTrsPsbAcntFilter = _.filter(
        variables.rlhrTrsPsbAcnt,
        function (info) {
          return info.efctVal == state.bankCd.efctVal;
        }
      );

      if (rlhrTrsPsbAcntFilter.length == 0 && state.rlhrAcntAttrYn == "1") {
        dialog.alert(
          "1회차 실시간이체가 불가한 은행계좌입니다. 다른 은행계좌로 변경하시기 바랍니다."
        );
        return false;
      }

      // 통합계약목록조회 ( FNGCTGLO0133 )
      axios.json("/retrieveSbcpChnDivCd.do", {}).then(function (object) {
        let sbcpChnDivCd = object.data.sbcpChnDivCd;

        if (sbcpChnDivCd == "01") {
          router.push({ name: "cfntChnChngPrctr" });
          return false;
        } else {
          let param = {};
          param.prctrNo = sessionUserInfo.prctrNo;
          param.orgCd = sessionUserInfo.orgCd;

          signupload(param);
        }
      });
    };

    function signupload(param) {
      // 전자서명 파일 업로드 및 파일생성 로그 저장 (FNGCMMMO0122)
      variables.prctrAtTrsAcntRegInfBcVo.rlhrTrsAcntRegYn =
        state.rlhrAcntAttrYn;

      var atTrsCoVo = JSON.parse(JSON.stringify(variables.atTrsCoVo));
      atTrsCoVo.rowStat = "8";
      param.body = variables.prctrAtTrsAcntRegInfBcVo;
      param.inqAtTrsCoVo = atTrsCoVo;

      //신규저장할 계좌정보 셋팅
      variables.atTrsCoVo.trsDdCd = state.trsDd;
      variables.atTrsCoVo.rspnCd = state.bankCd.efctVal;
      variables.atTrsCoVo.rqeDivCd = "1";
      variables.atTrsCoVo.rowStat = ""; // 저장 초기화 변수
      variables.atTrsCoVo.itgrAtTrsRqeYn = state.itgrTrsAgr;

      //금융기간구분코드 생성
      if (state.bankCd.efctVal.substr(0, 1) == "0") {
        variables.atTrsCoVo.fncInstDivCd = "1";
      } else if (state.bankCd.efctVal.substr(0, 1) == "2") {
        variables.atTrsCoVo.fncInstDivCd = "2"; //증권사
      } else {
        variables.atTrsCoVo.fncInstDivCd = "";
      }
      param.newRegYn = "N";
      param.newAtTrsCoVo = variables.atTrsCoVo;
      //계좌정보 등록
      // 자동이체계좌등록 (FNGCTNLO0025)
      axios.json("/registPrctrAtTrsAcnt.do", param).then(function (result) {
        let data = result.data;
        if (!util.isNull(data.msg) && data.msg.standCd == "FNGCT000011") {
          next();
        } else {
          if (!util.isNull(data.msg)) {
            dialog.alert(result.data.msg.standMsg).then(function () {
              window.location.reload();
            });
          } else {
            dialog.alert("계좌등록이 실패하였습니다.`").then(function () {
              window.location.reload();
            });
          }
        }
      });
    }

    function next() {
      let acntInf = {
        rlhrAcntAttrYn: state.rlhrAcntAttrYn,
        idfNo: state.polhdRel.idfNo,
        bankNm: state.bankCd.efctValNm,
        // rlhrTrsYn: state.rlhrTrsYn,
        atTrsCoVo: variables.atTrsCoVo,
        inempYn: variables.inempYn,
        polhdRelNm: state.polhdRelNm,
        dporBdt: util.cf_GetJuminToBirth(state.polhdRel.idfNo),
        regRefNoEncry: state.acntNo,
        th3pedporNm: state.dporNm,
        fncInstCdNm: state.bankCd.efctValNm,
      };

      store.commit("elcSgnInf/changeAcntInf", acntInf);
      router.push({ name: "sbcpDocSgn" });
    }

    const getMasterButton = () => {
      let result = "계좌정보입력 및 예금주확인";

      let checkLst = [];

      checkLst.push(state.atTrsAgrYn);
      checkLst.push(state.trsDd);
      checkLst.push(state.dporCnfFlag);

      if (state.rlhrRegYn) {
        if (_.every(checkLst)) {
          result = state.rlhrAcntAttrYn
            ? "다음으로 이동"
            : "실시간 자동이체 여부 선택";
        }
      } else {
        result = _.every(checkLst) ? "다음으로 이동" : result;
      }

      return result;
    };

    return {
      state,
      load,
      sessionUserInfo,
      openSelect,
      dporCnf,
      acntInfStr,
      acntNoEl,
      keyPad,
      getMasterButton,
    };
  },
};
</script>
